import { useFormik } from 'formik';
import React, { useState } from 'react';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import api from '../../../../components/api';
import { ArrowLeft, MailIcon, Print } from '../../../../components/atoms/icons';
import Modal from '../../../../components/organisms/modals';
import Form from '../../../../components/molecules/forms';

/* eslint-disable */
function ViewInvoice() {
    const ref = React.createRef();
    const navigation = useNavigate();
    const [data, setData] = useState(JSON.parse(sessionStorage.getItem('invoice') ?? '{}'))
    const [result, setResult] = React.useState<any>(undefined);
    const [fileData, setFileData] = React.useState<any>(null)
    const [fileError, setFileError] = React.useState(false)
    const { mutate: sendInvoice, isLoading: sendInvoiceLoad } = useMutation(api.customerSupport.sendInvoice, {
        onMutate: (variables) => console.log(variables),
        onSuccess: (data) => {
            console.log(data);
            setResult(data);
        },
        onError: (error) => {
            console.log(error);
            setResult(error);
        },
    });


    const yupSchema = yup.object({
        name: yup.string().required('name can\'t be empty'),
        email: yup.string().email('Email format is incorrect').required('Email can\'t be empty'),
    });

    const formik = useFormik({
        initialValues: {
            name: '',
            email: '',
        },
        validationSchema: yupSchema,
        onSubmit: (values) => {
            let formeData = new FormData();
            formeData.append('file', fileData);
            formeData.append('name', values?.name);
            formeData.append('email', values?.email);
            if (!!fileData) {
                sendInvoice(formeData)
            } else {
                setFileError(true)
            }
        },
    });

    const getTotal = () => {
        if (data?.parts?.length > 0) {
            return data?.billAmount + data?.parts?.map((x: any) => x?.split(':')?.[1]?.trim()).reduce((sum: any, total: number) => Number(sum) + Number(total), 0)
        } else {
            return data?.billAmount
        }
    }

    const getDateFormat = (date: Date) => `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;

    const renderModalBody = React.useMemo(() => {
        return (
            <div>
                <Form.Default
                    id="name"
                    placeholder="Enter Name"
                    type="text"
                    value={formik.values.name}
                    onBlur={formik.handleBlur}
                    isInvalid={!!formik.errors.name && formik.touched.name}
                    errorMsg={formik.errors.name}
                    onChange={(e) => formik.setFieldValue('name', e.target.value)}
                />
                <div className='mt-4'>
                    <Form.Default
                        id="email"
                        placeholder="Enter Email"
                        type="text"
                        value={formik.values.email}
                        onBlur={formik.handleBlur}
                        isInvalid={!!formik.errors.email && formik.touched.email}
                        errorMsg={formik.errors.email}
                        onChange={(e) => formik.setFieldValue('email', e.target.value)}
                    />
                </div>
                <div className='mt-4'>
                    <input type='file' accept='application/pdf' onClick={(event: any) => { event.target.value = '' }} onChange={(e: any) => {
                        setFileError(false)
                        setFileData(e.target.files[0])
                    }} />
                    {fileError && <p className='file-error'>file can't be empty</p>}
                </div>
            </div>
        );
    }, [formik, result]);

    const afterSendInvoice = () => {
        setResult(undefined);
        formik.setFieldValue('name', '')
        formik.setFieldValue('email', '')
    };


    const generatePDF = async (id: any) => {
        const pdfData = await api.customerSupport.getPDFByInvoiceId(id);
        const link = document.createElement('a');
        link.href = URL.createObjectURL(pdfData?.data);
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();

        // cleanup
        setTimeout(() => {
            link?.parentNode?.removeChild(link);
        }, 3000);
    };

    return (
        <div className='invoice_container'>
            <div className="invoice_doc container ">
                <div className="invoice_top_bar">
                    <button
                        onClick={() => navigation(-1)}
                        type="button"
                        className="border-0 bg-transparent"
                        style={{ marginTop: '4px' }}
                    >
                        <ArrowLeft />
                    </button>
                    <span>Invoice</span>
                    <div className='d-flex'>
                        <div className="d-flex align-items-center justify-content-end" style={{ width: 120 }}>
                            <Modal.Default
                                cancelLabel="Cancel"
                                submitLabel="Send"
                                title="Send Invoice"
                                body={renderModalBody}
                                closeButton
                                isLoading={sendInvoiceLoad}
                                onAfterResult={afterSendInvoice}
                                result={result}
                                //   onInit={() => formik.setFieldValue('id', id)}
                                onSubmit={formik.handleSubmit}
                            >
                                <button
                                    type="button"
                                    className="border-0 pedding-btn bg-transparent"
                                    style={{ marginTop: '4px' }}
                                >
                                    <MailIcon />
                                </button>
                            </Modal.Default>
                        </div>

                        <button
                            onClick={() => generatePDF(data?.id)}
                            type="button"
                            className="border-0 bg-transparent"
                            style={{ marginTop: '4px', paddingLeft: '10px' }}
                        >
                            <Print />
                        </button>
                    </div>
                </div>
                <div className="invoice_doc_second" style={{ borderBottom: '1px solid rgb(191, 191, 191)' }}>
                    <h3 className="invoice_heading">{`INVOICE#${data?.id}`}</h3>
                    <div className="row invoice_doc_second_list">
                        <div className="col-sm-4">
                            <p>Bill To: </p>
                            <p>Ship To: </p>
                            <p>Bill Date: </p>
                        </div>
                        <div className="col-sm-6">
                            <p>{sessionStorage.getItem('clientName')}</p>
                            <p>{sessionStorage.getItem('clientName')}</p>
                            <p>{getDateFormat(new Date(data?.billDate))}</p>
                        </div>
                    </div>
                </div>
                <div className="invoice_doc_second">
                    <div className="row invoice_doc_second_list">
                        <div className="col-sm-4">
                            <p>Service Date: </p>
                            <p>Labor Hour(s): </p>
                            <p>Labor Rate: </p>
                            <p>Bill Date: </p>
                        </div>
                        <div className="col-sm-6">
                            <p>{getDateFormat(new Date(data?.serviceDate))}</p>
                            <p>{data?.laborHour}</p>
                            <p>{`$${data?.laborRate ?? 0} per hour`}</p>
                            <p>{getDateFormat(new Date(data?.billDate))}</p>
                        </div>
                    </div>
                </div>

                <div className="row table_part">
                    <div className="col-sm-12">
                        <table className="table bordered">
                            <thead className="">
                                <tr>
                                    <th scope="col">S.No</th>
                                    <th scope="col">Description</th>
                                    <th scope="col">Qty</th>
                                    <th scope="col">Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td>Bill</td>
                                    <td>1</td>
                                    <td>${data?.billAmount}</td>
                                </tr>
                                {data?.parts?.length > 0 ?
                                    data?.parts?.map((part: any, index: number) => {
                                        const name = part.split(':')?.[0]?.trim()
                                        const price = part.split(':')?.[1]?.trim()
                                        return (
                                            <tr>
                                                <th scope="row">{index + 2}</th>
                                                <td>{name}</td>
                                                <td>1</td>
                                                <td>${price}</td>
                                            </tr>
                                        );
                                    })
                                    : null}
                            </tbody>
                            <tfoot className="table_footer_data">
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td>Total:</td>
                                    <td>${getTotal()}</td>
                                </tr>
                            </tfoot>
                        </table>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default ViewInvoice;